import * as R from 'ramda';
import React, { Fragment } from 'react';
import { compose, withState, withHandlers } from 'react-recompose';
// components
import { TextComponent } from '../../../components/text';
import { FormGroupTitleComponent } from '../../../components/form-group-title';
// forms
import { FormGroupWrapper } from '../../../forms';
// helpers/constants
import * as G from '../../../helpers';
// icons
import * as I from '../../../svgs';
// ui
import { Box, Flex, IconWrapper } from '../../../ui';
// feature reference
import { enhanceReferences } from '../hocs';
//////////////////////////////////////////////////

const enhance = compose(
  enhanceReferences,
  withState('isOpened', 'toggleOpened', true),
  withHandlers({
    onToggleSection: (props) => () => {
      props.toggleOpened(R.not(props.isOpened));
    },
  }),
);

const Header = () => (
  <Flex justifyContent='left'>
    <Box p='10px 20px' width={320}>
      {G.getWindowLocale('titles:value', 'Value')}
    </Box>
    <Box p='10px 20px'>
      {G.getWindowLocale('titles:name', 'Name')}
    </Box>
  </Flex>
);

const iconColor = G.getTheme('tables.rows.iconColor');

const renderReferences = (props) => {
  const { references, withoutActions, handleRemoveItem, handleOpenReference } = props;

  return R.values(references).map((item, i) => (
    <Flex key={i} justifyContent='left'>
      <Flex width={320} p='10px 20px'>
        {
          R.not(withoutActions) &&
          <Fragment>
            <IconWrapper
              pr={15}
              cursor='pointer'
              onClick={() => handleRemoveItem(item.guid)}
            >
              {I.trash(iconColor)}
            </IconWrapper>
            <IconWrapper
              pr={15}
              cursor='pointer'
              onClick={() => handleOpenReference(item)}
            >
              {I.pencil(iconColor)}
            </IconWrapper>
          </Fragment>
        }
        <TextComponent
          width={200}
          display='block'
          title={item.value}
          withEllipsis={true}
        >
          {item.value}
        </TextComponent>
      </Flex>
      <Box p='10px 20px'>
        <TextComponent
          width={360}
          display='block'
          title={item.value}
          withEllipsis={true}
        >
          {item.name}
        </TextComponent>
      </Box>
    </Flex>
  ));
};

export const ReferencesComponent = (props) => (
  <FormGroupWrapper isOpened={props.isOpened}>
    <FormGroupTitleComponent
      withArrowDown={true}
      isOpened={props.isOpened}
      onClickLabel={props.handleOpenReference}
      onToggleFormGroup={props.onToggleSection}
      text={G.getWindowLocale('titles:references', 'References')}
      endIcon={props.withoutActions ? null : I.plusRound(G.getTheme('icons.iconColorWhite'))}
    />
    <Box bg='white'>
      <Header />
      {renderReferences(props)}
    </Box>
  </FormGroupWrapper>
);

export default enhance(ReferencesComponent);
